import { cva, type VariantProps } from 'class-variance-authority';
import Loader2 from 'lucide-react/dist/esm/icons/loader-2';
import type { HTMLAttributes, Ref } from 'react';

import { cn } from '@/lib/utils';

const spinnerVariants = cva('inline-flex animate-spin', {
  variants: {
    size: {
      sm: 'size-3',
      md: 'size-4',
      lg: 'size-5',
      xl: 'size-6'
    },
    color: {
      default: '',
      primary: 'text-primary',
      muted: 'text-muted-foreground'
    },
    inline: {
      true: 'mr-2',
      false: ''
    }
  },
  defaultVariants: {
    size: 'md',
    color: 'default',
    inline: false
  }
});

export interface SpinnerProps
  extends
    VariantProps<typeof spinnerVariants>,
    Omit<HTMLAttributes<HTMLSpanElement>, 'children' | 'color'> {
  className?: string;
}

export const Spinner = ({
  size,
  color,
  inline,
  className,
  ref,
  ...props
}: SpinnerProps & { ref?: Ref<HTMLSpanElement> }) => {
  return (
    <span ref={ref} className={cn(spinnerVariants({ size, color, inline }), className)} {...props}>
      <Loader2 className="size-full" />
    </span>
  );
};

Spinner.displayName = 'Spinner';
